const moniepointAgencyProd = 'https://atm.moniepoint.com';
const moniebookEnvURL = 'https://moniebook.development.teamapt.com';
// const moniepointAgency = 'https://beta.frontoffice.mab.console.teamapt.com';
const stagingHost = 'https://frontoffice.mab.staging.teamapt.com';
const moniepointAgency = 'https://frontoffice-v2.development.moniepoint.com';
const stagingOnboarding = 'https://mab.onboarding.staging.teamapt.com';
const moniepointSaving = 'https://mab-loans-savings.mab.development.teamapt.com';
const moniepointLoans = 'https://moniepoint-loans-service.development.teamapt.com';
const moniepointArea = 'https://area.mab.console.teamapt.com';
const moniepointCards = 'https://card.mab.development.moniepoint.com';
const moniepointInsurance = 'https://moniepoint-insurance-service.development.teamapt.com';
const moniepointLogistics = 'https://logistics-service.development.moniepoint.com';
const moniepointWithdrawal = 'https://withdrawals.development.moniepoint.com';
const moniepointDeposit = 'https://deposits.development.moniepoint.com';
const moniepointDashboard = 'https://moniepoint-dashboard-service.development.moniepoint.com';
const erpIntegrations = 'https://moniepoint-pos-backend-service.development.moniepoint.com';
const grafanaUrl = 'https://grafana.development.teamapt.com/d/kn5MofqMz/test?orgId=1';
const moniepointOfflinePayment = 'https://offline-payment.mab.development.teamapt.com';
const kuwego = 'https://api.bo.new.kuwego.development.teamapt.com';
const kuwegoImageUrl = 'https://files.new.kuwego.development.teamapt.com';
const kuwegoLoans = 'https://api.v2.core.loans.moniepoint.development.teamapt.com';
const fileService = 'https://files.new.kuwego.development.teamapt.com';
const reportService = 'https://statements.mab.development.moniepoint.com';
// const reportService = 'https://report.mab.development.teamapt.com';
const notificationService = 'https://moniepoint-notification-service.development.teamapt.com';
const onBoardingService = 'https://onboarding.mab.development.moniepoint.com';
const avsService = 'https://avs.development.moniepoint.com';
const onBoardingMoniepointDevService = 'https://onboarding.mab.development.moniepoint.com';
const accountingService = 'https://moniebook-core-service.development.teamapt.com';
const stagingAccountingService = 'https://moniepoint-accounting-service.staging.teamapt.com';
const accountsService = 'https://accounts.development.moniepoint.com';
const fvCoreDevService = 'https://fv-core-service.development.moniepoint.com';
const fvCoreStagingService = 'https://fv-core-service.staging.teamapt.com';
const terminalService = 'https://terminal.mab.development.teamapt.com';
const terminalServiceOCIDev = 'https://moniepoint-terminal-service.development.moniepoint.com';
const wclService = 'https://wcl-management-service.development.moniepoint.com';
const loanGatewayService = 'https://loans-api-gateway.development.moniepoint.com';
const wclPortfolioManagementService = 'https://loans-participants-service.development.moniepoint.com';
const enableWclCombinedGuarantorSubmission = true;
const enableWclPlatformHttpHeader = false;
const wclStagingService = 'https://wcl-management-service.staging.teamapt.com';
const moniepointUrl = 'https://moniepoint.development.teamapt.com';
const moniepointStagingUserUrl = 'https://users.mab.staging.teamapt.com';
const moniepointDevUserUrl = 'https://users.development.moniepoint.com';
const rmOnboardingUrl = 'https://rm.onboarding.mab.development.teamapt.com';
const moniepointBillPayment = 'https://bill-payment.mab.development.teamapt.com';
const moniepointGamification = 'https://moniepoint-gamification-service.development.moniepoint.com';
const offlineSalesStaging = 'https://offline-sales.staging.moniepoint.com';
const offlineSalesDev = 'https://offline-sales.development.moniepoint.com';
const moniepointMFALoom = 'https://mfa.loom.development.moniepoint.com';
const runningService = moniepointAgency;
const showMobileWebView = true;
const showComplianceView = true;
const allowPosRequest = true;
const showConsolidationView = true;
const showFeeWaiver = true;
const showCapitalLoansMenu = true;
const showCapitalLoansWeb = true;
const showDownloadPosAccountDetails = true;
const defaultOtpCountDown = 600;
const showTraining = true;
const showNewSettingView = true;
const showReActLinkOnBoardingBO = true;
const metaMapFlowId = '62ea31664733dc001d80f9ac';
// const metaMapLowLevelAccountInfoFlowId = '63df9ef51db23e001ce05651';
const metaMapLowLevelAccountInfoFlowId = '63bd31422afaa3001c941354';
const metaMapPersonalInfoFlowId = '636b748264ac5e001d8f6aac';
const showKycRegisteredBusiness = true;
const showYearlySummaryReport = true;
const showTermsAndConditionsModalBO = true;
const showTermsAndConditionsModalBRM = true;
const showTermsAndConditionsModalRM = true;
const showTermsAndConditionsModalSC = true;
const showTransactionShareButton = false;
const staffUserDepositRequest = false;
const staffUserAirtimeRequest = false;
const staffUserBillPaymentRequest = false;
const showRecuringTransferLimit = true;
const showInfiniteRecuringTransfer = true;
const metaMapBrmProfileVerificationLivelisnessFlowId = '63b3e2aa78cbe0001c640748';
const showStaffUsersMenu = false;
const showStaffDesignationsMenu = false;
const showBoNewApprovalsUi = true;
const showNewAccountView = true;
const showNewTransfer = false;
const showTransferLimitModal = true;
const removeTransferAllTransactions = true;
const showNewTransferExportURL = true;
const extendedStatementDownload = true;
const showBusinessOwnerStatementExport = true;
const businessOwnerExtendedStatementDownload = true;
const dailyBusinessStatementDownload = true;
const dailyTerminalStatementDownload = true;
const moniepointOrchestratorUrl = 'https://notification-orchestrator.development.moniepoint.com';
const hideBusinessesForInviteAdmin = true;
const showNewFlowInviteStaff = true;
const moniepointWorkflowUrl = 'https://moniepoint-workflow.mab.development.teamapt.com';
const moniepointCRMService = 'https://moniepoint-crm-service.development.teamapt.com';
const enableStaffUserInvite = true;
const showOldTransactionPinMenu = false;
const showKycTransactionLimits = true;
const useNewWithdrawal = true;
const useNewPurchase = true;
const showUserPinModalOnBoLogin = true;
const useConsolidatedAllForAllTransactions = false;
const showBoDashboardForDigitalBo = true;
const moniepointDeliveryService = 'https://delivery-service.development.moniepoint.com';
const moniepointApplicationStoreUrl = 'https://q6as.adj.st/personal/onboarding?rc=cycccc&adj_t=15ha060e&rC=';
const showSignUpPasscodeFlow = true;
const showBrmLGAUpdateOnFvsView = true;
const showFVSAddressVerificationRoutes = true;
const showFVSAddressVerificationMenu = true;
const allowBRMReUpdateLGAOnFVS = true;
const fvsAddressVerificationTabsToHide = 'priority';
const fvsLoginRouteWithQueryParam = 'https://fv.fo-ui.development.teamapt.com/login-with-moniepoint?token=';
const showFVSPendingCountBannerOnBRMDashboard = true;
const fvsShowBRMCanUpdateBOAddress = true;
const fvsShowAddressVerificationWidget = true;
const scPerformanceStartPeriod = '04-2024';
const statementService = 'https://statements.mab.development.moniepoint.com';
const fvsFileService = 'https://files.new.kuwego.development.teamapt.com';
const showSCRMCashout = false;
const showBRMPRMCashout = true;
const showPRMPerformanceTracker = true;
const enableSubBrm = true;
const showKioskMarketers = true;
const showSCPerformanceReports = true;
const showSPOPerformanceTracker = true;
const moniepointPosServiceDev = 'https://moniepoint-pos-backend-service.development.moniepoint.com';
const showMoniebookOnboardingOnBODetails = true;
const moniebookServiceUrl = 'https://api-moniebook.development.moniepoint.com';
const moniebookDashboardUrl = 'https://moniebook-web.development.moniepoint.com';
const removeTcDocumentForBRM = true;
const showPerformanceTrackerCommissionHistory = true;
const showPosInsuredFlowV2 = true;
const showBusinessRemapping = true;
const showBrmOnboardingNextOfKin = true;
const terminalInventoryService = 'https://moniepoint-terminal-inventory-service.development.moniepoint.com';
const livelinessServiceDev = 'https://lvs.development.moniepoint.com';
const livelinessServiceStaging = 'https://lvs.staging.moniepoint.com';
const showBrmOnboardingIdentification = true;
const showCmMenuForRm = true;
const showScMenuForRm = true;
const showBrmApprovalsMenuForCm = true;
const showAccountsMenuForCm = true;
const showLimitApprovalMenuForCM = false;
const showMyCoursesMenuForCM = false;
const getBrmApprovalsPendingClaimRequestsForCm = false;
const getBrmApprovalsProcessingClaimRequestsForCm = false;
const getBrmApprovalsTreatedClaimRequestsForCm = false;
const showBrmApprovalsActionColumnForCm = true;
const showPerformanceTrackerMenuForCm = false;
const businessesRmAgentsTablePageSize = 10;
const businessesAgentsTablePageSize = 10;
const enableAccountsWalletTransactionsForCm = false;
const enableAccountsHistoricalTransactionsForCm = false;
const enableAccountsCashoutForCm = false;
const hideBrmPrmSelfOnboardingAddressVerification = false;
const enableBrmPrmRequestUpdation = true;

const FEATURES = [
    {
        image: 'assets/images/svgs/invoice.svg',
        description:
            'Keep track of where your money goes. Record business transactions inflows and outflows. Record cash transactions. Transfer & POS transactions automatically categorized by the platform can be updated.',
        header: 'Basic Bookkeeping',
    },
    {
        image: 'assets/images/svgs/report.svg',
        description: 'Have access at any time to your up-to-date Business’s Income Statement (Profit & Loss)and Cashflow reports.',
        header: 'Basic Reports',
    },
    {
        image: 'assets/images/files.png',
        description:
            'Stay on top of your business’s financial position with access to your balance sheet. Get a 360 degree view of all your business accounts.',
        header: 'Advanced Reports',
    },
    {
        image: 'assets/images/svgs/advanced-bookkeeping.svg',
        description:
            'Create and manage your business’s Chart of Accounts. Pass entries for Asset, Liability, Equity, Income & Expense account categories. Create sub-categories to better represent the different facets of your business.',
        header: 'Advanced Bookkeeping',
    },
    {
        image: 'assets/images/svgs/categorization.svg',
        description:
            'Have your bank account transactions automatically and intelligently reconciled. All transactions performed on our platform will be automatically tagged appropriately saving you time. this feature can be switched on or off anytime, and transactions can always be re-categorized if need.',
        header: 'Automatic Transaction Categorization',
    },
];

export const CONFIG = {
    CLIENT_VERSION: '0.0.0',
    USE_UNIFIED_PROVISIONAL_OFFER_FLOW: true,
    MONIEPOINT_HOST: `${runningService}`,
    MONIEPOINT_OFFLINE_SALES_URL: `${offlineSalesDev}`,
    MONIEBOOK_ENV_URL: `${moniepointDevUserUrl}`,
    MONIEBOOK_FEATURE_SHOW_REFERRALS: false,
    MONIEPOINT_SAVINGS: `${moniepointSaving}`,
    MONIEPOINT_USER_URL: `${moniepointDevUserUrl}`,
    MONIEPOINT_TERMINAL_INVENTORY: terminalInventoryService,
    MONIEPOINT_LOANS: `${moniepointLoans}`,
    WLC_MANAGEMENT: `${wclService}`,
    LOAN_GATEWAY_SERVICE_URL: `${loanGatewayService}`,
    WCL_PORTFOLIO_MANAGEMENT: `${wclPortfolioManagementService}`,
    LMS_SERVICE_URL: 'https://mock.apidog.com/m1/746768-723698-default',
    MARKUP_SERVICE_URL: 'https://mock.apidog.com/m1/746768-723698-default',
    WCL_SERVICE_URL_V2: 'https://mock.apidog.com/m1/746768-723698-default',
    OVD_SERVICE_URL_V2: 'https://mock.apidog.com/m1/746768-723698-default',
    ENABLE_WCL_COMBINED_GUARANTOR_SUBMISSION: enableWclCombinedGuarantorSubmission,
    ENABLE_WCL_PLATFORM_HTTP_HEADER: enableWclPlatformHttpHeader,
    USE_WCL_BUSINESS_OWNER_REPAYMENT_ACCOUNTS: true,
    USE_WCL_BUSINESS_OWNER_DISBURSEMENT_ACCOUNTS: false,
    USE_WCL_BUSINESS_ADDRESS_VERIFICATION_V2: true,
    SHOW_WCL_IN_BUSINESS_USER_DASHBOARD: true,
    SHOW_OVERDRAFT_RUNNING_LOANS_V2: true,
    SHOW_OVERDRAFT_RUNNING_LOANS_V2_SALES_VALUE: false,
    SHOW_LOAN_PRODUCT_SELECTION_FLOW: true,
    USE_OVD_NEW_AGREEMENT_FLOW: true,
    SHOW_OVERDRAFT_RUNNING_LOANS_V2_LEARN_ABOUT_OVERDRAFT: false,
    SHOW_OVERDRAFT_RUNNING_LOANS_V2_DEACTIVATE_OVERDRAFT: false,
    SHOW_WCL_BUSINESS_USER_DASHBOARD_NEW_BADGE: true,
    ENABLE_WCL_GEOLOCATION_HIGH_ACCURACY: false,
    MONIEPOINT_CARDS: `${moniepointCards}`,
    MONIEPOINT_OFFLINE_PAYMENT: `${moniepointOfflinePayment}`,
    MONIEPOINT_INSURANCE: `${moniepointInsurance}`,
    MONIEPOINT_DEPOSIT: `${moniepointDeposit}`,
    MONIEPOINT_WITHDRAWAL: `${moniepointWithdrawal}`,
    MONIEPOINT_AREA: `${moniepointArea}`,
    MONIEPOINT_ONBOARDING: `${onBoardingService}`,
    MONIEPOINT_AVS: `${avsService}`,
    MONIEPOINT_LOGISTICS: `${moniepointLogistics}`,
    MONIEPOINT_REPORT: `${reportService}`,
    MONIEPOINT_NOTIFICATION: `${notificationService}`,
    MONIEPOINT_ACCOUNTING: `${accountingService}`,
    MONIEPOINT_ACCOUNTING_STAGING: `${stagingAccountingService}`,
    MONIEPOINT_ACCOUNTS: `${accountsService}`,
    MONIEPOINT_FV_CORE: `${fvCoreDevService}`,
    MONIEPOINT_TERMINAL: `${terminalServiceOCIDev}`,
    MONIEPOINT_BILL_PAYMENT: `${moniepointBillPayment}`,
    MONIEPOINT_GAMIFICATION: `${moniepointGamification}`,
    MONIEPOINT_REFERRALS_CASHOUT_SERVICE: moniepointDeposit,
    MONIEPOINT_DASHBOARD: moniepointDashboard,
    MONIEPOINT_POS_ERP_INTEGRATION: erpIntegrations,
    MONIEPOINT_MFA_LOOM: moniepointMFALoom,
    MONIEPOINT_STATEMENT: `${statementService}`,
    GRAFANA_URL: `${grafanaUrl}`,
    DOMAIN_ID: 'MONIEPOINT',
    CLIENT_ID: 'WEB',
    SHOW_MOBILE_WEB_VIEW: showMobileWebView,
    DEFAULT_OTP_COUNT_DOWN: defaultOtpCountDown,
    mock: true,
    APP_TIMEOUT: 1000,
    ALLOW_AGENT_LOGIN: true,
    REDIRECT_ACCESS_TOKEN: null,
    REDIRECT_LOGIN_USER_TYPE: '1',
    KUWEGO_URL: kuwego,
    KUWEGO_IMAGE_URL: kuwegoImageUrl,
    KUWEGO_LOANS: kuwegoLoans,
    FILE_SERVICE: fileService,
    FVS_FILE_SERVICE: fvsFileService,
    SHOW_COMPLIANCE_VIEW: showComplianceView,
    ALLOW_POS_REQUEST: allowPosRequest,
    SHOW_CONSOLIDATION_VIEW: showConsolidationView,
    ALLOW_SIGN_UP: true,
    ALLOW_SIGN_UP_FOR_BRM: true,
    ALLOW_BRM_ADD_BUSINESS: true,
    FEATURES,
    SHOW_TRAINING_VIEW: showTraining,
    SHOW_NEW_SETTING_VIEW: showNewSettingView,
    SHOW_FEE_WAIVER: showFeeWaiver,
    SHOW_CAPITAL_LOANS_MENU: showCapitalLoansMenu,
    SHOW_CAPITAL_LOANS_WEB: showCapitalLoansWeb,
    SHOW_DOWNLOAD_POS_ACCOUNT_DETAILS: showDownloadPosAccountDetails,
    ALLOW_KYC: true,
    SHOW_RE_ACT_LINK_ONBOARDING_BO: showReActLinkOnBoardingBO,
    META_MAP_FLOW_ID: metaMapFlowId,
    META_MAP_LOW_LEVEL_ACCOUNT_FLOW_ID: metaMapLowLevelAccountInfoFlowId,
    META_MAP_PERSONAL_INFO_FLOW_ID: metaMapPersonalInfoFlowId,
    SHOW_KYC_REGISTERED_BUSINESS: showKycRegisteredBusiness,
    SHOW_POS_REQUEST_MENU: false,
    SHOW_CARDS_MENU: true,
    SHOW_SUPPORT: true,
    SHOW_CASHOUT_BUTTON: true,
    SHOW_BRM_DASHBOARD_V2: true,
    BUFFER_SIZE: 1000,
    LOG_TIMEOUT: 60000,
    MONIEPOINT_URL: moniepointUrl,
    SHOW_YEARLY_SUMMARY_REPORT: showYearlySummaryReport,
    SHOW_TERMS_AND_CONDITIONS_MODAL_BO: showTermsAndConditionsModalBO,
    SHOW_STAFF_USERS_MENU: showStaffUsersMenu,
    SHOW_STAFF_DESIGNATION_MENU: showStaffDesignationsMenu,
    SHOW_TERMS_AND_CONDITIONS_MODAL_BRM: showTermsAndConditionsModalBRM,
    SHOW_TERMS_AND_CONDITIONS_MODAL_RM: showTermsAndConditionsModalRM,
    SHOW_TERMS_AND_CONDITIONS_MODAL_SC: showTermsAndConditionsModalSC,
    STAFF_USER_DEPOSIT_REQUEST: staffUserDepositRequest,
    STAFF_USER_AIRTIME_REQUEST: staffUserAirtimeRequest,
    STAFF_USER_BILL_PAYMENT_REQUEST: staffUserBillPaymentRequest,
    SHOW_RECURRING_TRANSFER_LIMIT: showRecuringTransferLimit,
    SHOW_INFINITE_RECURRING_TRANSFER: showInfiniteRecuringTransfer,
    SHOW_WRITEOFF_PROMOTION: true,
    SHOW_BRM_CASHOUT_PIN_FLOW: true,
    JWT_EXPIRY_CHECK: 60000,
    SHOW_SWITCH_TO_REG_BUSINESS: false,
    SHOW_TRANSACTION_SHARE_BUTTON: showTransactionShareButton,
    SHOW_DASHBOARD_ALERT_WIDGET: true,
    SHOW_BRM_WRITEOFF_ACTION: true,
    SHOW_BRM_RESET_PIN_FLOW: true,
    SHOW_BUSINESS_EFFICIENCY_UPDATE: true,
    META_MAP_BRM_PROFLIE_VERIFICATION_LIVELINESS_FLOW_ID: metaMapBrmProfileVerificationLivelisnessFlowId,
    SHOW_BRM_VERIFICATION_METAMAP_LIVELINESS_FLOW: true,
    SHOW_EOD_PRINTING: true,
    SHOW_SELF_TEST: true,
    RM_ONBOARDING_URL: rmOnboardingUrl,
    SHOW_TERMINAL_ASSIGNMENT_UPDATE: false,
    USE_V2_SELECTION_PAGE: true,
    SHOW_ONBOARDING_SUPPORT: false,
    SHOW_COURSES_WARNING_ON_CASHOUT: true,
    SHOW_BO_NEW_APPROVALS_UI: showBoNewApprovalsUi,
    SHOW_BO_DEFAULT_APPROVAL_UI_NEW: false,
    SHOW_APP_DOWNLOAD_BANNER: false,
    USE_NEW_ONBOARDING_FLOW: false,
    USE_NEW_SIGN_UP_FLOW: false,
    USE_NEW_KYC_FLOW: true,
    MONIEPOINT_ORCHESTRATOR_SERVICE: moniepointOrchestratorUrl,
    SHOW_NOTIFICATION_PREFERENCE: 'SELF_ONBOARDED_UNREGISTERED_AGENT_WALLET,SELF_ONBOARDED_LOW_LEVEL_AGENT_WALLET',
    SHOW_DOWNLOADABLE_MATERIAL: true,
    SHOW_NEW_ACCOUNT_VIEW: showNewAccountView,
    SHOW_NEW_TRANSFER: showNewTransfer,
    SHOW_TRANSFER_LIMIT_MODAL: showTransferLimitModal,
    REMOVE_TRANSFER_ALL_TRANSACTIONS: removeTransferAllTransactions,
    SHOW_NEW_TRANSFER_EXPORT_URL: showNewTransferExportURL,
    ROUTE_TO_DASHBOARD_AFTER_ONBOARDING: false,
    USE_MOBILE_MAX_FILE_SIZE: true,
    DEFAULT_TIME_FOR_METAMAP_STATUS_CALL: 60,
    SET_DEFAULT_NOTIFICATION_PREFERENCE: false,
    SHOW_LOGIN_USSD: false,
    SHOW_TERMINAL_ASSIGNMENT_BUSINESS_UPDATE: true,
    SHOW_BRM_APPROVE_TAB: false,
    SHOW_BRM_ONBOARDING_FOR_CM: true,
    SHOW_DOCUMENT_APPROVE_TAB: false,
    SHOW_LIMIT_APPROVE_TAB: true,
    SHOW_BRM_BUSINESS_ACCOUNT: true,
    SHOW_BUSINESS_ACCOUNT_CASHOUT_BUTTON: false,
    CAN_SHOW_PARTNERS_DEPOSIT_COMMISSIONS_BALANCE: false,
    HIDE_BUSINESSES_FOR_INVITE_ADMIN: hideBusinessesForInviteAdmin,
    SHOW_NEW_FLOW_INVITE_STAFF: showNewFlowInviteStaff,
    EXTENDED_STATEMENT_DOWNLOAD: extendedStatementDownload,
    BUSINESS_OWNER_EXTENDED_STATEMENT_DOWNLOAD: businessOwnerExtendedStatementDownload,
    DAILY_BUSINESS_STATEMENT_DOWNLOAD: dailyBusinessStatementDownload,
    DAILY_TERMINAL_STATEMENT_DOWNLOAD: dailyTerminalStatementDownload,
    SHOW_BUSINESS_OWNER_STATEMENT_EXPORT: showBusinessOwnerStatementExport,
    SHOW_USER_PIN_MENU: true,
    SHOW_SC_RM_CASHOUT: true,
    MONIEPOINT_WORKFLOW_URL: moniepointWorkflowUrl,
    MONIEPOINT_CRM_SERVICE: moniepointCRMService,
    SHOW_KYC_LEVEL_BANNER: true,
    ENABLE_STAFF_USER_INVITE: enableStaffUserInvite,
    SHOW_CARD_PENETRATION_WIDGET: true,
    SHOW_OLD_TRANSACTION_PIN_MENU: showOldTransactionPinMenu,
    USE_NEW_TRANSACTION_PIN: true,
    SHOW_KYC_TRANSACTION_LIMITS: showKycTransactionLimits,
    USE_NEW_WITHDRAWAL: useNewWithdrawal,
    USE_NEW_PURCHASE: useNewPurchase,
    USE_NEW_AIRTIME: false,
    SHOW_USER_PIN_MODAL_ON_BO_LOGIN: showUserPinModalOnBoLogin,
    SHOW_SC_TERMINAL_ASSIGNMENT: true,
    USE_CONSOLIDATED_ALL_FOR_ALL_TRANSACTIONS: useConsolidatedAllForAllTransactions,
    SHOW_BO_DASHBOARD_FOR_DIGITAL_BO: showBoDashboardForDigitalBo,
    CAN_OPEN_BO_DIGITAL_ACCOUNT: true,
    CARDS_CAN_USE_USER_PIN: true,
    MONIEPOINT_DELIVERY_SERVICE: `${moniepointDeliveryService}`,
    CAN_USE_DELIVERY_SERVICE: false,
    SHOW_BO_TABLE_V2: true,
    SHOW_POS_UPDATE: true,
    SHOW_SWAP_TERMINAL_UPDATE: true,
    CAN_USE_SUBLGA: true,
    CAN_BRM_EXTEND_GRACE_PERIOD_AFTER_EXPIRATION: false,
    TIME_ZONE: 'Africa/Lagos',
    WEB_BICON: true,
    SHOW_TERMINAL_COMMISSION_FEE_SPLIT: true,
    USE_KYC_API_ON_DASHBOARD: true,
    USE_NEW_LOGIN_API: true,
    CAN_ADD_BUSINESSES_FOR_PENDING_BO: false,
    CAN_USE_SOFT_ONBOARDING: true,
    CARDS_CAN_COLLECT_CARDS: true,
    SHOW_PROFILE_BUTTON_ON_BO_PROFILE: false,
    USE_UUID_FOR_DEVICE_ID: true,
    USE_NIBSS_BVN_VERIFICATION: false,
    USE_OTP_CHANGE_PASSWORD_AND_PIN: false, // deprecated
    USE_NEW_CHANGE_PASSWORD: true, // TODO: remove later
    USE_NEW_RESET_USER_PIN: true, // TODO: remove later
    USE_NEW_STATEMENT_FLOW: true,
    SHOULD_USE_NEW_BVN_FLOW: false,
    SHOW_BRM_CARD_SALES_AGENT: true,
    SHOW_BULK_TRANSFER: true,
    SHOW_BRM_CARD_NEW_UI: true,
    SHOW_SC_TERMINAL_SWAP: true,
    USE_OLD_BUSINESS_OWNER_KYC: false,
    SHOW_REFERRALS: true,
    SHOW_REFERRALS_CASHOUT: true,
    HIDE_PDF_STATEMENT_DOWNLOAD: true,
    SHOW_NEW_TERMINAL_ASSIGNMENT_REQUESTS: true,
    USE_NEW_BO_STATEMENT_DOWNLOAD: true,
    USE_OVERDRAFT_PAYMENT: true,
    CAN_USE_BUSINESS_NAME_CHANGE: true,
    SHOW_NEW_CARD_REQUESTS: false,
    ADD_BUSINESS_DETAILS_MENU: true,
    CAN_USE_SMILE_ID: true,
    SHOW_ACCOUNT_CLOSURE: true,
    SHOW_POS_ERP_INTEGRATION: true,
    SHOW_BRM_PUSH_CARDS_TO_SALES_AGENT: true,
    SHOW_COLLECT_CARD_MENU: false,
    MONIEPOINT_APPLICATION_STORE_URL: moniepointApplicationStoreUrl,
    BRM_PUSH_TO_SALES_AGENT_CARD_COUNT: 5,
    REFERRAL_PRE_REGISTRATION_API_RETRY_COUNT: 10,
    REFERRAL_PRE_REGISTRATION_API_RETRY_INTERVAL: 2000,
    BRM_CAN_RETRIEVE_CARDS: true,
    SHOW_NEW_PROFILE_UPDATE_VIEW: true,
    USE_KYC_NIN_FLOW: true,
    BRM_CAN_USE_FLEXIBLE_CARD_COST: true,
    USE_BRM_KYC_NIN_FLOW: true,
    CAN_USE_IDENTITY_TOKEN: false,
    USE_LOGIN_OPTION: true,
    CAN_CHANGE_PASSCODE: true,
    SHOW_SIGN_UP_PASSCODE_FLOW: showSignUpPasscodeFlow,
    USE_CARD_PUSH_BATCH_SETTINGS: true,
    SHOW_USSD_BANKING_CHANNEL_SETTINGS: false,
    USSD_BANKING_CHANNEL_MODAL_MAXIMUM_USERS: 5,
    USE_NEW_FORGET_PASSCODE_FLOW: true,
    USE_ACCOUNT_NUMBER_ALIAS: true,
    VALIDATE_DUPLICATE_TRANSFERS: true,
    USE_NEW_KYC_LEVEL2_FLOW: true,
    USE_NEW_KYC_LEVEL3_FLOW: true,
    CAN_HIDE_KYC_LEVEL1_PRIMER: true,
    USE_NEW_BRM_KYC_LEVEL2_FLOW: true,
    USE_NEW_BRM_KYC_LEVEL3_FLOW: true,
    REWARDS_SERVICE_URL: 'https://moniepoint-rewards-service.development.moniepoint.com',
    SHOULD_SHOW_REWARDS: true,
    SHOULD_SHOW_REWARDS_V2: true,
    SHOULD_USE_UNIFIED_BANNER: true,
    BRM_CAN_USE_CONFIG_FLEXIBLE_CARD_COST: true,
    SHOW_TERMINAL_ACTIVITY_SCORE: true,
    USE_PROFILE_SETUP: true,
    USE_CARD_DEVICE_ID: true,
    USSD_BANKING_CODE: '*425*011#',
    USE_STAFF_USER_REFRESH_TOKEN: true,
    CAN_RESEND_OTP_VIA_WHATSAPP: true,
    CAN_USE_NEW_USSD: true,
    SHOW_BO_PERFORMANCE: true,
    USE_KAMONA_SIGN_IN: false,
    SHOW_CAC_BANNER: true,
    SHOW_BRM_CAC_INCOMPLIANT_BO: true,
    USE_DEVICE_ID_DECRYPTION: false,
    USE_ASYNC_LIVELINESS_CHECK: true,
    SHOW_UPDATE_DATE_OF_BIRTH: false,
    SHOW_LOAN_PREQUALIFICATION_AGGREGATORS: true,
    SHOW_LOAN_PREQUALIFICATION_RC: true,
    SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP: true,
    SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP_V2: true,
    USE_PREQUALIFIED_BOS_V2: true,
    USE_PREQUALIFICATION_LOOKUP_V2: true,
    SHOW_LOAN_AGGREGATORS_SCHEDULE_SIMULATION: true,
    FO_ENVIRONMENT: 'local',
    SHOW_INCOMPLIANT_KYC_BANNER: true,
    SHOW_BRM_INCOMPLIANT_KYC_BANNER: true,
    USE_AUTO_ADDRESS_APPROVAL: true,
    CARDS_REQUIRE_TERMS_AND_CONDITIONS: true,
    SHOW_INVENTORY: true,
    ENABLE_LIVENESS_FOR_CARD_ACTIVATION: true,
    CARD_TOOLS_UI_UPDATE_V1: true,
    USE_MERGE_DUPLICATE_PROFILE_FLOW: true,
    ALLOW_BRM_USE_PASSPORT_PHOTOGRAPH_FOR_BO_ONBOARDING: true,
    ALLOW_BVN_FOR_KYC_LEVEL_1_BUSINESS_ONBOARDING: true,
    VALIDATE_BO_WCL_KYC: false,
    USE_GOOGLE_MAP_JAVASCRIPT_API: false,
    GEOLOCATION_THRESHOLD_IN_METER: 500,
    USE_ADDRESS_REVALIDATION: true,
    SHOW_TERMINAL_QUOTA_UPDATE: true,
    SHOW_BRM_LGA_UPDATE_ON_FVS_VIEW: showBrmLGAUpdateOnFvsView,
    SHOW_FVS_ADDRESS_VERIFICATION_ROUTES: showFVSAddressVerificationRoutes,
    SHOW_FVS_ADDRESS_VERIFICATION_MENU: showFVSAddressVerificationMenu,
    ALLOW_BRM_RE_UPDATE_LGA_ON_FVS: allowBRMReUpdateLGAOnFVS,
    FVS_ADDRESS_VERIFICATION_TABS_TO_HIDE: fvsAddressVerificationTabsToHide,
    FVS_LOGIN_ROUTE_WITH_QUERY_PARAM: fvsLoginRouteWithQueryParam,
    SHOW_FVS_PENDING_COUNT_BANNER_ON_BRM_DASHBOARD: showFVSPendingCountBannerOnBRMDashboard,
    FVS_SHOW_ADDRESS_VERIFICATION_WIDGET: fvsShowAddressVerificationWidget,
    FVS_SHOW_BRM_CAN_UPDATE_BO_ADDRESS: fvsShowBRMCanUpdateBOAddress,
    USE_NEW_COMPLIANCE_URLS: true,
    MINIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS: 7,
    COUNTRY_FLAGS_URL: 'https://cdn-prod.moniepoint.com/country-flags/',
    MAXIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS: 14,
    SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN: true,
    USE_CAC_BUSINESS_AFFILIATE_FLOW: true,
    USE_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW: true,
    USE_BRM_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW: true,
    SHOW_SWAP_UPDATE_FOR_SC_AND_BRM: true,
    METAMAP_SCRIPT_URL: 'https://web-button.metamap.com/button.js',
    USE_KYC_CORRECTIONS_V2: true,
    USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_KYC: true,
    USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_BRM_KYC: true,
    USE_REGISTERED_BUSINESS_PRIMER_LABEL: true,
    USE_REGISTERED_BUSINESS_ROUTE: true,
    SHOW_NEW_FAULTY_FLOW: true,
    SC_PERFORMANCE_START_PERIOD: scPerformanceStartPeriod,
    SHOW_PERFORMANCE_TRACKER_FOR_RM_SC: true,
    USE_PENDING_LOAN_TIMELINE_V2: true,
    USE_LOOM_MFA_SDK: true,
    MINIMUM_MFA_SIGN_UP_ALERT_KYC_LEVEL: 1,
    MINIMUM_MFA_SIGN_UP_ALERT_TEXT:
        'Multi-factor Authentication (MFA) provides an extra layer of security for your account.||From September 9, you will need MFA to make single transactions above ₦5,000,000.00.',
    USE_NEW_DAILY_LIMIT_FLOW: true,
    ENFORCE_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW: true,
    ENFORCE_OPTION_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW: true,
    SHOW_TERMINAL_RETRIEVAL_UPDATE: true,
    SHOW_MY_APPROVAL_REQUESTS: true,
    CAN_MAKE_STATE_LGA_OPTIONAL: false,
    USE_DAILY_STATEMENT_DATE_RANGE: true,
    SHOW_GLOBAL_SWAP_UPDATE: true,
    USE_STATEMENT_REPORT_URL: true,
    SHOW_KYC_LVL1_BUSINESS_NAME_DESCRIPTION_SIZE: false,
    OTP_RESEND_V2: true,
    USE_2FA_FLOW_USER_PIN_RESET: true,
    USE_2FA_FLOW_FORGOT_PASSCODE: true,
    USE_2FA_FLOW_FORGOT_PASSWORD: true,
    USE_2FA_FLOW_PASSCODE_CHANGE: true,
    USE_2FA_FLOW_PASSWORD_CHANGE: true,
    USE_ONBOARDING_MODULE_LAZY_LOADER: true,
    USE_NEW_LOAN_FACILITATOR_INPUT: true,
    SHOW_PND_AND_LIENS_BANNER: true,
    USE_ANALYTICS_TRACKING_SERVICE_IN_LOANS: true,
    SHOW_MONIECRM: true,
    SHOW_TICKET_MANAGER: true,
    CUSTOMER_IO_WRITE_KEY: '9441edf3877d4405400b:ead0b9d7cdf63fc081d8',
    PARTNER_ONBOARDING_MIGRATION: true,
    SHOW_BRM_ONBOARDING: true,
    SHOW_REPAIR_CODE_UPDATE: true,
    SHOW_CUSTOM_TRANSACTION_FIELD_CONFIG: true,
    MONIEPOINT_POS: `${moniepointPosServiceDev}`,
    SHOW_PROFILE_EMAIL_UPDATE_BUTTON: true,
    SHOW_PROFILE_PHONE_NUMBER_UPDATE_BUTTON: true,
    SHOW_PROFILE_DOB_UPDATE_BUTTON: true,
    SHOW_PROFILE_IMAGE_UPDATE_BUTTON: true,
    CUSTOMER_IO_CDN_URL: 'https://cdp-eu.customer.io',
    SHOW_MONIEBOOK_ONBOARDING_ON_BO_DETAILS: showMoniebookOnboardingOnBODetails,
    MONIEBOOK_SERVICE_URL: moniebookServiceUrl,
    MONIEBOOK_DASHBOARD_URL: moniebookDashboardUrl,
    SHOW_MONIEBOOK_AUTO_ONBOARD_BANNER: true,
    REMOVE_TC_DOCUMENT_FOR_BRM: removeTcDocumentForBRM,
    SHOW_PERFORMANCE_TRACKER_COMMISSION_HISTORY: showPerformanceTrackerCommissionHistory,
    USE_OTP_WHATSAPP_DEVICE_REGISTRATION: true,
    USE_OTP_WHATSAPP_FORGOT_PASSCODE: true,
    USE_OTP_WHATSAPP_FORGOT_PASSWORD: true,
    USE_OTP_WHATSAPP_PASSCODE_CHANGE: true,
    USE_OTP_WHATSAPP_PASSWORD_CHANGE: true,
    USE_OTP_WHATSAPP_RESET_USER_PIN: true,
    SEND_SMS_OTP_2FA: false,
    WHATSPP_OTP_COUNTDOWN_IN_SECONDS: 60,
    SHOULD_USE_KYC_LVL2_UPGRADE_FLOW: true,
    CARDS_USE_BRM_AUTHORITIES: true,
    SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_UPDATE: true,
    USE_NEW_OTP_DESIGN_DEVICE_REGISTRATION: true,
    USE_NEW_TRANSFER_SUMMARY: false,
    SHOW_UPDATE_TERMINAL_STATUS_ACTION: true,
    USE_PROVISIONAL_OFFER_GENERATION_FLOW: true,
    SHOW_PROFILE_ADDRESS_UPDATE_BUTTON_KYC_LEVEL: 0,
    SHOW_LIENS_ON_ACCOUNTS_PAGE: false,
    CARDS_USE_NEW_ASSIGNMENT_API: false,
    SHOW_BRM_PRM_CASHOUT: showBRMPRMCashout,
    SHOW_PRM_PERFORMANCE_TRACKER: showPRMPerformanceTracker,
    ENABLE_SUB_BRM: enableSubBrm,
    SHOW_KIOSK_MARKETERS: showKioskMarketers,
    SHOW_SC_PERFORMANCE_REPORTS: showSCPerformanceReports,
    SHOW_SPO_PERFORMANCE_TRACKER: showSPOPerformanceTracker,
    MONIECRM_URL: 'https://cdn-staging.moniepoint.com/moniecrm',
    ADDRESS_VERIFICATION_MFE_URL: 'https://cdn-staging.moniepoint.com/address-verification-web/address-verification',
    TICKET_MANAGER_URL: 'https://cdn-staging.moniepoint.com/moniedesk/ticket-manager-ui-dev/ticket-manager',
    MONIEPOINT_PAYMENT_URL: 'https://cdn-staging.moniepoint.com/payments',
    SHOW_BRM_TERMINAL_TRANSACTION_SUMMARY: true,
    SHOW_BRM_CARD_SALES_PERFORMANCE_UPDATE: true,
    SHOW_WITHHOLDING_TAX: false,
    SHOW_CASHOUT_FEE: false,
    HIDE_SIDEMENU_ON_MOBILE_APP: true,
    SHOW_CM_MENU_FOR_SC: true,
    SHOW_CLUSTERS_MENU_FOR_SC: false,
    SHOW_CM_MENU_FOR_RM: showCmMenuForRm,
    SHOW_SC_MENU_FOR_RM: showScMenuForRm,
    SHOW_BRM_APPROVALS_MENU_FOR_CM: showBrmApprovalsMenuForCm,
    SHOW_LIMIT_APPROVAL_MENU_FOR_CM: showLimitApprovalMenuForCM,
    SHOW_MY_COURSES_MENU_FOR_CM: showMyCoursesMenuForCM,
    SHOW_PERFORMANCE_REPORTS_FOR_CM: true,
    DISABLE_AUTO_LOGOUT_ON_MOBILE_APP: true,
    USE_LOAN_EXPIRED_V2: true,
    SHOW_POS_WEB_INTEGRATION: true,
    SHOW_POS_WEB_HOOK: true,
    SHOW_BRM_PENDING_LIST: true,
    CARDS_DELIVERY_USE_CARD_SERVICE: true,
    ENABLE_MARKETER_ONBOARDING: true,
    SHOW_PROVISIONAL_OFFERS_LIST: false,
    SHOW_PROVISIONAL_OFFERS_CONTACT_US: false,
    SHOW_PROVISIONAL_OFFER_LOAN_TENURE: true,
    SHOW_PROVISIONAL_OFFER_REPAYMENT_FREQUENCY: true,
    SHOW_PROFILE_NAME_UPDATE_BUTTON: true,
    ENABLE_PROFILE_UPDATE_BUTTON_KYC_LEVEL: 2,
    SHOW_PROFILE_DOB_NEW_UPDATE_BUTTON: true,
    SHOW_PROFILE_DOB_NEW_UPDATE_SECTION: true,
    SHOW_KFS_PROVISIONAL_OFFER: true,
    SHOW_LOAN_REQUEST_FLOW_TENURE: true,
    SHOW_LOAN_REQUEST_FLOW_REPAYMENT_FREQUENCY: true,
    SHOW_REPAYMENT_PLAN_PROVISIONAL_OFFER: true,
    USE_KYC_BVN_NATIONALITY: true,
    USE_BRM_KYC_BVN_NATIONALITY: true,
    SHOW_POS_INSURED_FLOW_V2: showPosInsuredFlowV2,
    SHOW_BRM_INSURE_TERMINAL_FLOW: true,
    SHOW_INSURANCE_INFO: true,
    SHOW_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI: true,
    SHOW_RETRIVE_BUTTON_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI: true,
    HIDE_BO_KYC_LVL1_BACK_BUTTON: true,
    SHOW_INSURANCE_INFO_KFS: true,
    SHOW_REMOTE_GROWTH_MODULE: true,
    SHOW_REMOTE_ADDRESS_VERIFICATION_MODULE: true,
    SHOW_DEVICES_MFE: true,
    SHOW_NOTIFICATION_PREFERENCE_MFE: true,
    SHOW_BUSINESS_TYPE_MFE: false,
    SHOW_LANGUAGE_MFE: true,
    SHOW_OTHERS_MFE: true,
    SHOW_TRANSFER_CONFIGURATION_MFE: true,
    SETTINGS_MFE_URL: 'https://cdn-staging.moniepoint.com/settings/settings',
    LOANS_DASHBOARD_WIDGET_URL: 'https://cdn-staging.moniepoint.com/loans/dev/dashboard-widget',
    LOANS_HOST_URL: 'http://localhost:4300',
    LOANS_MARKUP_URL: 'http://localhost:4301',
    LOANS_WCL_URL: 'http://localhost:4302',
    LOANS_OVD_URL: 'http://localhost:4302',
    LOANS_ASSETS_URL: 'http://localhost:4304',
    LOANS_LOCALES_URL: 'http://localhost:4303',
    USE_NEW_LOAN_APP: true,
    SHOW_LOANS_DASHBOARD_WIDGET: true,
    USE_NEW_LOAN_AGREEMENT_FLOW: true,
    USE_FIRST_LOAN_DISBURSAL_ACCOUNT: true,
    TRANSFER_VALIDATION_FAILURE_MODAL_TITLE: 'Transfer Validation Failed',
    GROWTH_URL: 'https://cdn-staging.moniepoint.com/growth-dev/growth',
    GROWTH_V2_URL: 'https://cdn-staging.moniepoint.com/growth-dev/growth-v2',
    USE_MONIEPOINT_MFB_LOGO: true,
    SHOW_LICENSED_AND_SECURED_INFO: true,
    SHOW_WELFARE_ACCOUNT_FOR_BRM: true,
    SHOW_WELFARE_ACCOUNT_FOR_SC: true,
    SHOW_WELFARE_ACCOUNT_FOR_RM: true,
    SHOW_BUSINESS_REMAPPING: showBusinessRemapping,
    SHOW_BRM_ONBOARDING_PROOF_OF_ADDRESS: false,
    ALWAYS_SHOW_CM_INFO: false,
    SHOW_BRM_ONBOARDING_NEXT_OF_KIN: showBrmOnboardingNextOfKin,
    SHOW_BRM_BUSINESS_RECATEGORIZATION_NOTIFICATION: true,
    BUSINESSES_RM_AGENTS_TABLE_PAGE_SIZE: businessesRmAgentsTablePageSize,
    BUSINESSES_AGENTS_TABLE_PAGE_SIZE: businessesAgentsTablePageSize,
    SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_CLEANUP: true,
    SHOW_TERMS_AND_CONDITION_CHECKBOX: true,
    SHOW_STAFF_PROFILE_UPDATE_BUTTON: false,
    SHOW_BRM_ONBOARDING_IDENTIFICATION: showBrmOnboardingIdentification,
    SHOW_SAYT_V2: true,
    ENABLE_LOGIN_LOCATION_HEADERS: true,
    ENABLE_MANDATORY_LOGIN_LOCATION_ACCESS: false,
    USE_NEW_BO_KYC_LEVEL3_V3_FLOW: true,
    OKHI_API_KEY: '01J9VPGCXJJRDCR4BVBQB50VHK',
    OKHI_BRANCH_ID: '67080a4de25a4d900b33a17f',
    SHOW_FACE_VERIFICATION_IN_KYC_LVL3: true,
    SHOW_BUSINESS_BULK_INSURANCE_UPDATE: true,
    PROFILE_SETUP_MFE_URL: 'https://cdn-staging.moniepoint.com/onboarding/bo-profile-setup',
    SHOW_PROFILE_SETUP_MFE: true,
    MONIEPOINT_SAVINGS_V2_URL: 'https://mab-loans-savings.development.moniepoint.com',
    SHOW_DISBURSEMENT_ACCOUNT_CONFIRMATION_MODAL: true,
    S_CODE1: '',
    S_CODE2: '',
    USE_NEW_PRIMARY_ACCOUNT_FLAG_ON_DISBURSEMENT_ACCOUNTS_ENDPOINT: true,
    USE_NEW_RENEWAL_SUBMISSION_ENDPOINT: true,
    SHOW_BRM_ONBOARDING_CLUSTER_NAME: true,
    SHOW_OVERDRAFT_MANUAL_REPAYMENT: true,
    GET_BRM_APPROVALS_PENDING_CLAIM_REQUESTS_FOR_CM: getBrmApprovalsPendingClaimRequestsForCm,
    GET_BRM_APPROVALS_PROCESSING_CLAIM_REQUESTS_FOR_CM: getBrmApprovalsProcessingClaimRequestsForCm,
    GET_BRM_APPROVALS_TREATED_CLAIM_REQUESTS_FOR_CM: getBrmApprovalsTreatedClaimRequestsForCm,
    SHOW_BRM_APPROVALS_ACTION_COLUMN_FOR_CM: showBrmApprovalsActionColumnForCm,
    SHOW_BUSINESS_CATEGORY_UPDATE: true,
    UPDATE_BUSINESS_CATEGORY_URL: '',
    SHOW_PERFORMANCE_TRACKER_MENU_FOR_CM: showPerformanceTrackerMenuForCm,
    SHOW_ACCOUNTS_MENU_FOR_CM: showAccountsMenuForCm,
    USE_ADDITIONAL_BUSINESS_KYC_LEVEL1: true,
    BRM_USE_ADDITIONAL_BUSINESS_KYC_LEVEL1: true,
    USE_MULTIPLE_BUSINESS_TYPES: true,
    SHOW_BRM_BUSINESS_TYPES: true,
    STORE_FRONT_IMAGE_MAX_SIZE: 5120000,
    MAX_ALLOWED_BUSINESS_TYPES: 5,
    ENABLE_LOCATION_DURING_PAYMENT: true,
    ENFORCE_LOCATION_DURING_PAYMENT: true,
    ACCOUNT_UPGRADE_MFE_URL: 'https://cdn-staging.moniepoint.com/account-upgrade-dev',
    SHOW_ACCOUNT_UPGRADE_MFE: true,
    SHOW_PARTNER_UPGRADE_MFE: true,
    USE_NEW_TERMINALS_ENDPOINT: true,
    MONIEDESK_API_BASE_URL: 'https://moniepoint-moniepointcx-service.development.moniepoint.com',
    MONIEDESK_CRM_SERVICE: 'https://moniepoint-crm-service.staging.teamapt.com',
    MONIEDESK_ENTITY: '508574b8-c651-470b-8538-f2ae88b3cd46',
    SHOW_POS_TC: true,
    ENABLE_ONBOARDING_LOCATION_HEADERS: true,
    USE_POLICY_DOCUMENTS_API: true,
    USE_FACETEC_LIVELINESS: false,
    USE_BRM_FACETEC_LIVELINESS: false,
    LIVELINESS_SERVICE_URL: `${livelinessServiceDev}`,
    MFE_CDN_IDENTITY_VERIFICATION_URL: 'https://cdn-staging.moniepoint.com/onboarding/identity-verification',
    ENABLE_ACCOUNTS_WALLET_TRANSACTIONS_FOR_CM: enableAccountsWalletTransactionsForCm,
    ENABLE_ACCOUNTS_HISTORICAL_TRANSACTIONS_FOR_CM: enableAccountsHistoricalTransactionsForCm,
    ENABLE_ACCOUNTS_CASHOUT_FOR_CM: enableAccountsCashoutForCm,
    SHOW_TC_COMPLIANCE_DASHBOARD: true,
    USE_BRM_CREATE_BO_BUSINESS_PAGE: true,
    USE_UPDATED_KYC_LIMITS_FLOW: true,
    REMOVE_REFRESH_TOKEN_FOR_CM: true,
    REMOVE_CHECK_AUTH_FOR_CM: true,
    HIDE_BRM_PRM_SELF_ONBOARDING_ADDRESS_VERIFICATION: hideBrmPrmSelfOnboardingAddressVerification,
    USE_NEW_BUSINESS_TYPES_UI: true,
    MARKETER_ONBOARDING_MFE_URL: 'https://cdn-staging.moniepoint.com/onboarding/marketer-onboarding',
    SHOW_MARKETER_ONBOARDING_MFE: true,
    SHOW_CONSENT_MANAGEMENT_MFE: true,
    SHOW_POS_TERMINAL_CONDITION_DETAIL_FOR_SC: true,
    MONIEPOINT_CONSENT_MANAGEMENT_URL: 'https://consent-management-service.development.moniepoint.com',
    SHOW_PENDING_CONSENT_BANNER: true,
    SHOW_TERMINAL_SWAP_V4_UPDATE: true,
    USE_KYC_LVL_1_PREVENT_HYBRID_MERCHANT: true,
    USE_BRM_KYC_LVL_1_PREVENT_HYBRID_MERCHANT: true,
    USE_SOFT_ONBOARDING_PREVENT_HYBRID_MERCHANT: true,
    SHOW_SWAP_HISTORY: true,
    SHOW_QUOTA_FOR_NEW_TERMINALS_UPDATE: true,
    ENABLE_BRM_PRM_REQUEST_UPDATION: enableBrmPrmRequestUpdation,
    USE_UPDATED_CLUSTER_ASSIGNMENT_URL: true,
    SHOW_INVENTORY_STATUS_FILTER: true,
    ALLOW_SEARCH_BRM_CLUSTER_ASSIGNMENT: false,
};
